const readOnlyAccounts = ["teml@zhaw.ch"];
export function isReadOnlyAccount(mail) {
  return readOnlyAccounts.includes(mail);
}
